import React from 'react';
import {obterPublicacao} from '../actions/PublicacaoActions';
import {editarComentario} from '../actions/ComentarioActions';
import {obterContratoPeloNumero} from '../actions/ContratoActions';
import {obterPublicacoesPeloTipo} from '../actions/PublicacaoActions';
import {connect} from 'react-redux';
import {FTP_URL} from '../config/urls';

var PrintTemplate = require ('react-print');

class UltimasPaginasPublicacao extends React.Component {
  state = {
    paginas: []
  }

  componentWillMount(){
		let lastId = (this.props.match === undefined ? this.props.lastId : this.props.match.params.id);
		let lastTipo = (this.props.match === undefined ? this.props.lastTipo : this.props.match.params.tipo);
		let lastIdContrato = this.props.contrato.id; 
    this.props.obterContratoPeloNumero(lastId).then(() => {
      let tipo = "";
      switch(lastTipo){
        case 'paginacao':
          tipo = "Paginação";
          break;
        case 'capa-dura':
          tipo = "Capa Dura";
          break;
        case 'embalagens':
          tipo = "Embalagem";
          break;
        case 'encarte':
          tipo = "Encarte";
          break;
        case 'convite-simples':
          tipo = "Convite Simples";
          break;
        case 'senha-de-entrada':
          tipo = "Senha de Entrada";
          break;
        case 'missal':
          tipo = "Missal";
          break;
        case 'outros-produtos':
          tipo = "Outros Produtos";
          break;
        case 'personalizadas':
          tipo = "Personalizadas";
          break;
      }
      this.props.obterPublicacoesPeloTipo(tipo, lastIdContrato).then(() => {
        let publicacoes = this.props.publicacoes;
        let todasPaginas = {};
        publicacoes = publicacoes.filter(publicacao => publicacao.visivel);
        publicacoes.sort((a, b)=>{return new Date(b.dataPublicacao).getTime() - new Date(a.dataPublicacao).getTime()});
        //salva qual a ultima publicação pra editar mais tarde
        this.setState({ultimaPub:publicacoes[0]});
        publicacoes.forEach(publicacao => {
          publicacao.paginas.forEach(pagina => {
            if(!todasPaginas[pagina.nome]){
              todasPaginas[pagina.nome] = [];
            }
            if(publicacao.bloqueada || publicacao.dataAprovacao){
              pagina.bloqueada = true;
            }else{
              pagina.bloqueada = false;
            }
            todasPaginas[pagina.nome].push(pagina);
          });
        });
        let paginas = [];		
        Object.values(todasPaginas).forEach(paginasArray => {
          paginas.push(paginasArray[0]);
        });
        for(var key in todasPaginas){
          todasPaginas[key].shift();
        }
        paginas.sort((a, b) => a.tipo - b.tipo);
        paginas.sort((a, b) => a.numero - b.numero);
        this.setState({paginas});
      });
    });
  } 

  render(){
    return(
      <div className="box">
        <div className="box-body">
          {
            this.state.paginas.sort((a,b)=>{return a.numero - b.numero}).map((pagina) => (
              <div key={pagina.id} className="blocoPagina">
                <span style={{fontWeight: "bold"}}>{pagina.tipo.toUpperCase() + " " + pagina.numero}</span>
                <div style={{display: "flex", flexDirection: "row"}}>
                  <div>
                  <div id={`pagina${pagina.id}`} className="imgPagina">
                    <img id={`pagina-${pagina.id}`} style={{height: 150}} src={pagina ? `${FTP_URL}${pagina.publicacao}/${pagina.nome}` : null} />
                  </div>
                  </div>
                  <div className="comentariosPagina">
                  { 
                    pagina.aprovada === false ? 
                      pagina.comentarios.length > 0 ?  
                        pagina.comentarios.map((comentario, i) => (
                          <div key={comentario.id} style={{marginLeft: 20, maxWidth: 300, minWidth: 300}}>
                            <span style={{color: 'black', fontWeight: 600}}>Correção {i+1} - {new Date(comentario.data).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}: </span>
                            <span style={{maxWidth: "100%"}}>
                              {comentario.texto}
                            </span>
                          </div>
                        )) 
                      : null
                    :
                    <div key={pagina.numero} style={{marginLeft: 20, maxWidth: 300, minWidth: 300}}> 
                      Página aprovada em {new Date(pagina.dataAprovacao).toLocaleDateString('pt-BR', {timeZone: 'UTC'})} 
                    </div>
                  }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
		publicacao: state.publicacao.especifica,
		contrato: state.contrato.especifico,
		publicacoes: state.publicacao.todas
  }
}

export default connect(mapStateToProps, {obterPublicacao, editarComentario, obterContratoPeloNumero, obterPublicacoesPeloTipo})(UltimasPaginasPublicacao);



// WEBPACK FOOTER //
// ./src/views/UltimasPaginasPublicacao.js